import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiBadge = _resolveComponent("UiBadge")!

  return (_openBlock(), _createBlock(_component_UiBadge, {
    variant: $setup.badge.variant,
    "text-variant": $setup.badge.textVariant,
    size: "sm"
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString($setup.t(`whatsappMeta.phoneState.${$setup.state}`)), 1 /* TEXT */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["variant", "text-variant"]))
}